import type { UseQueryResult } from '@tanstack/react-query';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import { isBasketEmpty } from '../utils/basket-utils';
import { useBasket } from './useBasket';
import type { BasketAvailability } from './model/BasketAvailability';

export const useBasketAvailability = (): UseQueryResult<BasketAvailability> => {
    const { data } = useBasket();

    return useBffGet<BasketAvailability>(
        `/baskets/${data?.basketId}/availability`,
        [],
        [
            BffQueryKey.BASKET_AVAILABILITY,
            data?.basketId ?? '',
            data?.c_bopisStoreID ?? '',
            data?.c_goLocalStoreID ?? '',
        ],
        {
            basketCustomerId: data?.customerInfo?.customerId,
            enabled: !isBasketEmpty(data),
            keepPreviousData: true,
            refetchOnWindowFocus: 'always',
        },
    );
};
